import api from '@/services/Api'

class RentalProductCategoryService {
  async getRentalProductCategoryList(manufacturerId) {
    const response = await api.get('/rental/distributor/category/list/' + manufacturerId)
    return response.data
  }
}

export default new RentalProductCategoryService()
